import React, { useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Grid, InputLabel, IconButton, TextField } from "@material-ui/core";
import { AddBox, Cancel } from "@material-ui/icons";

// Contexts
import CampaignContext from "../../../../context/campaign/CampaignContext";
import ProductContext from "../../../../context/checkout/products/ProductContext";

const useStyles = makeStyles(() => ({
  button: {
    textTransform: "none",
    "&:focus": {
      outline: "none",
    },
    padding: 10,
  },
  list: {
    height: "100%",
  },
}));

const Presell = () => {
  const classes = useStyles();

  const { products } = useContext(ProductContext);
  const { form_data, form_error, setFormData, setFormError } =
    useContext(CampaignContext);

  const checkDuplicate = () => {
    // Remove Error Message
    for (let index in form_error.presell) {
      form_error.presell[index] = "";
    }

    // Cross Check Duplicate Product ID
    let product_list = {};

    for (let index in form_data.presell) {
      const id = form_data.presell[index];

      if (id) {
        if (!Object.keys(product_list).includes(String(id))) {
          product_list[id] = [index];
        } else {
          product_list[id].push(index);
        }
      } else {
        form_error.presell[index] = "Field cannot be empty!";
      }
    }

    // Insert Error Message
    for (let x in product_list) {
      const indexes = product_list[x];
      if (indexes.length > 1) {
        indexes.forEach(
          (index) => (form_error.presell[index] = "Presell Product Duplicated!")
        );
      }
    }

    setFormData(form_data);
    setFormError(form_error);
  };

  const addPresell = () => {
    const last_idx = Object.keys(form_data.presell).pop();

    let new_idx = 0;
    if (last_idx) new_idx = parseInt(last_idx) + 1;

    form_data.presell[new_idx] = "";
    form_error.presell[new_idx] = "";

    setFormData(form_data);
    setFormError(form_error);
  };

  const removePresell = (index) => {
    // form_data.presell.splice(index, 1);
    let i = parseInt(index)
    delete form_data.presell[index];
    delete form_error.presell[index];

    checkDuplicate();
  };

  const handleChange = (e) => {
    const index = e.target.name;
    const value = parseInt(e.target.value.replace(/\s+/g, ""));

    form_data.presell[index] = value;

    checkDuplicate();
  };

  return (
    <Grid
      item
      xs={6}
      container
      alignItems="flex-start"
      justifyContent="flex-start"
    >
      {/* Label */}{" "}
      <Grid item xs={12}>
        <Grid container justifyContent="flex-start" alignItems="center" item>
          <Grid item>
            <InputLabel shrink required>
              Presell(s){" "}
            </InputLabel>{" "}
          </Grid>{" "}
          <Grid item>
            <IconButton onClick={addPresell} className={classes.button}>
              <AddBox color="primary" />
            </IconButton>{" "}
          </Grid>{" "}
        </Grid>{" "}
      </Grid>
      {/* List */}{" "}
      <Grid item xs={12} className={classes.list}>
        {" "}
        {Object.entries(form_data.presell).map(([index, presell_id]) => {
          return (
            <Grid
              key={index}
              item
              xs={12}
              spacing={1}
              container
              alignItems="center"
              justifyContent="flex-start"
            >
              <Grid item xs={10}>
                <TextField
                  required
                  fullWidth
                  size="small"
                  margin="dense"
                  variant="outlined"
                  select
                  SelectProps={{
                    native: true,
                  }}
                  id="presell"
                  name="presell"
                  name={index}
                  onChange={handleChange}
                  value={products && presell_id}
                  error={form_error.presell[index] ? true : false}
                  helperText={form_error.presell[index]}
                >
                  <option value="" disabled />{" "}
                  {products &&
                    products.map((each) => {
                      return (
                        <option key={each.id} value={each.id}>
                          {" "}
                          {each.title}{" "}
                        </option>
                      );
                    })}{" "}
                </TextField>{" "}
              </Grid>
              <Grid item xs={2}>
                <IconButton
                  onClick={() => removePresell(index)}
                  className={classes.button}
                >
                  <Cancel color="error" />
                </IconButton>{" "}
              </Grid>{" "}
            </Grid>
          );
        })}{" "}
      </Grid>{" "}
    </Grid>
  );
};

export default Presell;
